import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ICertificadoTipoDTO } from '../dto/certificado-tipo.dto';

@Injectable({
  providedIn: 'root'
})
export class CertificadoTipoService {

  
  private urlEndPoint = environment.urlEndPoint.concat('/autenticado/certificado-tipos');

  constructor(private httpClient: HttpClient) { }

  public findAllByCerdcodigoAndLiqcodigo(cerdCodigo:string,liqCodigo:string): Observable<ICertificadoTipoDTO[]>{
    return this.httpClient.get<ICertificadoTipoDTO[]>(`${this.urlEndPoint}/obtener-lista-por-cerdcodigo-por-liqcodigo`, { params: { cerdCodigo,liqCodigo } });
  }

}
